import { render, staticRenderFns } from "./camaraQR.vue?vue&type=template&id=f4b2fa2e"
import script from "./camaraQR.vue?vue&type=script&lang=js"
export * from "./camaraQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports